import FormFieldComponent from '@/components/FormFieldComponent';
import { NavigationBlockerContext } from '@/context/NavigationBlockerContext';
import { STATE_VALIDATION } from '@/utils/constant';
import { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod';
export const CourtSchema = z.object({
  name: z.string({ message: 'Court name is required' }),
  code: z.string({ message: 'Court code is required' }),
  type: z.string({ message: 'Court type is required' }),
  county: z.string({ message: 'County is required' }),
  state: z.string({ message: 'State is required' }),
});
export const CourtForm = ({ displayType = 'PAGE' }: { displayType?: 'PAGE' | 'MODAL' }) => {
  const {
    control,
    formState: { isDirty },
  } = useFormContext();

  const { setIsDirty } = useContext(NavigationBlockerContext);

  useEffect(() => {
    setIsDirty(isDirty);
  }, [isDirty, setIsDirty]);

  return (
    <div className={`grid ${displayType === 'MODAL' ? 'grid-cols-1' : 'grid-cols-2'}  gap-4 `}>
      <div className={`grid ${displayType === 'MODAL' ? 'col-span-1' : 'col-span-2'}`}>
        <FormFieldComponent
          control={control}
          name="name"
          label="Court Name"
          placeholder="Enter Court Name"
          required
          capitalizeFirstLetter
          maxLength={200}
          autofocus={displayType === 'PAGE'}
        />
      </div>

      <FormFieldComponent
        control={control}
        name="code"
        label="Court Code"
        placeholder="Enter Court Code"
        required
        maxLength={20}
        allowNumber={false}
        allowSpecialCharacters={false}
        capitalize
        replaceRegex={/[^A-Za-z]/g}
      />

      <FormFieldComponent
        control={control}
        name="type"
        label="Court Type"
        placeholder="Enter Court Type"
        required
        capitalizeFirstLetter
        maxLength={50}
        allowNumber={false}
      />
      <FormFieldComponent
        control={control}
        name="county"
        label="County"
        placeholder="County"
        required
        capitalizeFirstLetter
        maxLength={50}
        allowNumber={false}
        allowSpecialCharacters={false}
      />
      <FormFieldComponent
        control={control}
        name="state"
        label="State"
        placeholder="State"
        required
        {...STATE_VALIDATION}
      />
    </div>
  );
};
